import * as React from "react";
import { FontAwesomeIcon } from "../../shared/FontAwesome";
import { QuestionType } from "../../../models/enums/QuestionType";

export default function QuestionTypeIcon({ type }) {
    switch (type) {
        case QuestionType.Description:
            return <FontAwesomeIcon fixedWidth icon={["far", "align-left"]} />;
        case QuestionType.RadioButton:
            return <FontAwesomeIcon fixedWidth icon={["far", "dot-circle"]} />;
        case QuestionType.CheckBox:
            return <FontAwesomeIcon fixedWidth icon={["far", "check-square"]} />;
        case QuestionType.OpenEndAnswer:
            return <FontAwesomeIcon fixedWidth icon={["far", "comment-alt-lines"]} />;
        case QuestionType.TextAnswer:
        case QuestionType.AutoComplete:
            return (
                <span className="fa-layers fa-fw">
                    <FontAwesomeIcon icon={["far", "rectangle-landscape"]} />
                    <FontAwesomeIcon icon={["far", "i-cursor"]} transform="shrink-8 right-3" />
                </span>
            );
        case QuestionType.NumericAnswer:
            return (
                <span className="fa-layers fa-fw">
                    <span
                        className="fa-layers-text"
                        style={{
                            fontWeight: 900,
                            fontSize: "0.8em",
                            fontFamily: "monospace",
                            transform: "translate(-90%, -53%)",
                        }}
                    >
                        0
                    </span>
                    <FontAwesomeIcon icon={["far", "rectangle-landscape"]} />
                    <FontAwesomeIcon icon={["far", "i-cursor"]} transform="shrink-8 right-3" />
                </span>
            );
        case QuestionType.NumericRanking:
            return <FontAwesomeIcon fixedWidth icon={["far", "sort-numeric-down"]} />;
        case QuestionType.DateTimeAnswer:
            return <FontAwesomeIcon fixedWidth icon={["far", "calendar"]} />;
        case QuestionType.DragDropRanking:
            return (
                <span className="fa-layers fa-fw">
                    <FontAwesomeIcon
                        icon={["far", "rectangle-wide"]}
                        transform="shrink-5 rotate-90 left-4"
                    />
                    <FontAwesomeIcon
                        icon={["far", "rectangle-wide"]}
                        transform="shrink-5 rotate-90 right-4"
                    />
                    <FontAwesomeIcon
                        icon={["fas", "square"]}
                        transform="shrink-7"
                        className="bg-color"
                    />
                    <FontAwesomeIcon icon={["far", "square"]} transform="shrink-7" />
                </span>
            );
        case QuestionType.CardSort:
            return (
                <span className="fa-layers fa-fw">
                    <FontAwesomeIcon icon={["far", "square"]} transform="shrink-6 left-2" />
                    <FontAwesomeIcon
                        icon={["fas", "square"]}
                        transform="shrink-6"
                        className="bg-color"
                    />
                    <FontAwesomeIcon icon={["far", "square"]} transform="shrink-6" />
                    <FontAwesomeIcon
                        icon={["fas", "square"]}
                        transform="shrink-6 right-2"
                        className="bg-color"
                    />
                    <FontAwesomeIcon icon={["far", "square"]} transform="shrink-6 right-2" />
                </span>
            );
        case QuestionType.DropDownList:
        case QuestionType.DrillDown:
            return (
                <span className="fa-layers fa-fw">
                    <FontAwesomeIcon icon={["far", "rectangle-landscape"]} />
                    <FontAwesomeIcon icon={["fas", "caret-down"]} transform="shrink-5 right-2" />
                </span>
            );
        case QuestionType.EmailAddressAnswer:
        case QuestionType.RespondentEmail:
            return <FontAwesomeIcon fixedWidth icon={["far", "envelope"]} />;
        case QuestionType.HybridGrid:
        case QuestionType.ChoiceGrid:
        case QuestionType.RunningTotal:
        case QuestionType.LookupTable:
            return <FontAwesomeIcon fixedWidth icon={["far", "table"]} />;
        case QuestionType.ImageSelector:
        case QuestionType.ImageChoiceGrid:
            return <FontAwesomeIcon fixedWidth icon={["far", "image-polaroid"]} />;
        case QuestionType.ImageAreaSelector:
        case QuestionType.ImageAreaEvaluator:
            return <FontAwesomeIcon fixedWidth icon={["far", "image"]} />;
        case QuestionType.RespondentPhone:
            return <FontAwesomeIcon fixedWidth icon={["far", "phone"]} />;
        case QuestionType.RespondentLanguage:
            return <FontAwesomeIcon fixedWidth icon={["far", "language"]} />;
        case QuestionType.RespondentTimeZone:
            return <FontAwesomeIcon fixedWidth icon={["far", "globe-europe"]} />;
        case QuestionType.RespondentMetaData:
            return <FontAwesomeIcon fixedWidth icon={["far", "person-sign"]} />;
        case QuestionType.Slider:
            return <FontAwesomeIcon fixedWidth icon={["far", "sliders-h"]} />;
        case QuestionType.StarRatingGrid:
        case QuestionType.NetPromoter:
            return <FontAwesomeIcon fixedWidth icon={["far", "star"]} />;
        case QuestionType.FileUpload:
            return <FontAwesomeIcon fixedWidth icon={["far", "upload"]} />;
        case QuestionType.Timer:
            return <FontAwesomeIcon fixedWidth icon={["far", "stopwatch"]} />;
        case QuestionType.CustomQuestion:
            return <FontAwesomeIcon fixedWidth icon={["far", "pencil"]} />;
        default:
            return <FontAwesomeIcon fixedWidth icon={["far", "question"]} />;
    }
}
